import { useReactiveVar } from '@apollo/client';
import MuiAppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import styled from '@mui/material/styles/styled';
import Toolbar from '@mui/material/Toolbar';
import PropTypes from 'prop-types';

import { globalLoaderVar } from '../../apollo/reactiveVariables';
import ActionButton from './ActionButton';
import Logo from './Logo';
import UserProfile from './UserProfile';

const StyledAppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  borderRadius: 'inherit',
  zIndex: theme.zIndex.drawer - 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: theme.drawer.width,
    width: `calc(100% - ${theme.drawer.width}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

function AppBar({ open }) {
  const globalLoader = useReactiveVar(globalLoaderVar);
  return (
    <StyledAppBar color="inherit" position="fixed" open={open}>
      <Toolbar>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Box
            sx={{
              ...(!open && { ml: 7 }),
            }}
          >
            <Logo />
          </Box>
          <Box>
            <ActionButton />
            <UserProfile />
          </Box>
        </Box>
      </Toolbar>
      {globalLoader && <LinearProgress color="secondary" />}
    </StyledAppBar>
  );
}

AppBar.propTypes = {
  open: PropTypes.bool.isRequired,
};
export default AppBar;
